export default __webpack_public_path__ + "static/media/research.e0ffe8a9.jpg";